(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results-common/assets/javascripts/api-calls/fetch-result.js') >= 0) return;  svs.modules.push('/components/numbergames/results-common/assets/javascripts/api-calls/fetch-result.js');

'use strict';

const isServer = svs.isServer;
let drawgamesApiCaller;
let logger;
let productMapping;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core');
  const trinidadCore = trinidad.core;
  drawgamesApiCaller = trinidadCore.components.require('tur', 'api-caller').drawgamesApiCaller;
  productMapping = trinidadCore.components.require('numbergames', 'product-mapping').productMapping;
  logger = trinidadCore.logger('numbergames:results-common');
} else {
  drawgamesApiCaller = svs.tur.apiCaller.drawgames;
  productMapping = svs.numbergames.productMapping;
  logger = svs.numbergames.results_common.logger;
}
async function fetchResult(_ref) {
  let {
    productId,
    drawNumber,
    req
  } = _ref;
  const productDrawId = productMapping.getProductDrawId(productId);
  if (drawNumber && !/[0-9]+/.test(drawNumber) || !productDrawId || isServer && !req) {
    logger.error("Invalid parameters. drawNumber ".concat(drawNumber, ", productId ").concat(productId));
    throw Error("results-common fetchResult Parameter error.");
  }
  try {
    const data = drawNumber ? await drawgamesApiCaller.getDrawProductDrawsResult({
      product: productDrawId,
      drawNumber,
      req
    }) : await drawgamesApiCaller.getDrawProductDrawsResultLatest({
      product: productDrawId,
      req
    });
    if (isServer) {
      if (data.result === null) {
        throw Error('fetchResult would return null');
      }
      return data.result;
    }
    return data.response.result;
  } catch (e) {
    logger.error("Failed to fetch result. code: ".concat(e.code, " message: ").concat(decodeURIComponent(e.message)), req);
    throw Error("Error from draw/".concat(productDrawId, "/draws/").concat(drawNumber, "/result"));
  }
}
if (isServer) {
  module.exports = {
    fetchResult
  };
} else {
  svs.numbergames.results_common.api_calls.fetchResult = fetchResult;
}

 })(window);